export class IndustrialCodeValue {
  industrialCodeValueId: number;
  name: string;
  value: number;
  displayLabel?: string;
}
